export default __webpack_public_path__ + "static/media/cat2.6fad6c17.png";